import Dashboard from "../Views/Dashboard.svelte";
import GetSummaryReport from "../Views/GetSummaryReport.svelte";
import Login from "../Views/Login.svelte";

export const routes = {
    '/': Login,
    '/auth': Login,
    '/dashboard': Dashboard,
    '/getSummaryReport/:id': GetSummaryReport 
}